import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { apiGet, apiSend } from '../perps-v1-shared/api';

// A quick-add favorite symbol, as persisted, in display order.
export interface FavoritePreset {
  id: string;
  symbol: string;
  displayOrder: number;
  operator: string;
  updatedAt: string;
  // True once the symbol has left the live perp universe (flipped delisted, or vanished from
  // coin metadata entirely — both report the same way). setFavoritePresets keeps refusing to
  // save any set that still contains one of these; this is what lets the console show which
  // row is the problem instead of leaving the admin stuck on an unexplained rejected save.
  isDelisted: boolean;
}

// Candidate pool item — symbols eligible to become a favorite. Shared candidate endpoint with Pins.
export interface PresetCandidate {
  id: string;
  symbol: string;
  displaySymbol: string;
  dex: string;
  volume24h?: number;
}

// getList -> GET /perps-v1/favorite-presets (already ordered by displayOrder)
export class PerpsV1PresetsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, _params: GetListParams): Promise<any> {
    if (resource !== Resources.perpsV1Presets) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const json = await apiGet<{ data: FavoritePreset[]; total: number }>(
      '/perps-v1/favorite-presets'
    );
    return { data: json?.data ?? [], total: json?.total ?? json?.data?.length ?? 0 };
  }
}

export const perpsV1PresetsDataProvider = new PerpsV1PresetsDataProvider();

export const presetsApi = {
  save: (symbols: string[]) =>
    apiSend<{ data: FavoritePreset[]; total: number }>('/perps-v1/favorite-presets', 'PUT', {
      symbols,
    }),
};

// Reuses the existing Pins candidate pool endpoint — same eligible-symbol universe.
export const candidatesApi = {
  list: () =>
    apiGet<{ data: PresetCandidate[]; total: number }>('/perps-v1/pins/candidates?page=1&size=1000'),
};
